/* Install this JS code in a custom liquid section in the theme footer */
/* Add a stylesheet with "msg_unavailable_class" and "msg_incentive_class" classes  in the theme assets */

const productHandle = window.themeData?.productHandle;

const i_debug = true;
let debug = "";
let cart_with_mag = false;

async function updateCart( inResfresh = false ) {
	
/*
[ alerte d'ajout illégitime de l'option Portrait lorsqu'il n'y a pas de magazine dans le panier ]
Ce produit ne peut être ajouté que si le numéro 18Bis est ajouté dans votre panier !

[ alerte d'éligibilité de l'option Portrait lorsqu'il y a un magazine dans le panier ]
Vous êtes éligible pour ajouter votre portrait dans le magazine !
Ajoutez [ce produit] à votre panier pour en profiter !
*/
	
	const msg_unavailable = "Ce produit ne peut être ajouté que si le numéro 18Bis, ou un pack l'incluant, est dans votre&nbsp;panier&nbsp;!";
	const msg_unavailable_class = "hum-unavailable-playlist";	
	const msg_incentive = "Vous êtes éligible pour faire apparaitre votre portrait&nbsp;dans&nbsp;le&nbsp;magazine.<br />Ajoutez <a href='/products/contribution-au-numero-reservee-aux-100-premiers' target='_self'>ce produit</a> à votre panier pour&nbsp;en&nbsp;profiter&nbsp;!";
	const msg_incentive_class = "hum-incentive-playlist";

	const p_valids = [
        "18-bis-lovecraft", 
        "hors-serie-lovecraft-couverture-exclusive", 
        "hors-serie-lovecraft-couverture-exclusive", 
        "pack-hors-serie-collector-affiche-copie", 
        "le-hors-serie-en-edition-collector", 
        "pack-lovecraft-affiche-abonnement-1-an-copie", 
        "pack-hors-serie-lovecraft-affiche-abonnement-2-ans", 
        "pack-hors-serie-lovecraft-collector-affiche-abonnement-2-ans", 
        "pack-hors-serie-lovecraft-collector-affiche-abonnement-1-an"
	];

    const p_playlist = "contribution-au-numero-reservee-aux-100-premiers";

    try {

        // Fetch the current cart items using Shopify AJAX
        const cartResp = await fetch('/cart.js');
        const cartData = await cartResp.json();
		const cart_value = cartData.total_price / 100;
        const is_cart_page = (window.location.pathname === '/cart');
        
        const cartItems = cartData.items.map(item => item.handle);
		const cartKeys = cartData.items.map(item => item.key);

        let has_one_valid = false;
        let has_playlist = false;
		let has_playlist_stock = false;
        let must_display_option = false;
        let must_delete_option = false;
		let disable_option_purchase = ( productHandle == p_playlist );

		// Fetch product JSON
		const response = await fetch(`/products/${p_playlist}.js`);
		if( response.ok ) {
			const product = await response.json();
			product.variants.forEach((variant) => {
				if( variant.available ) {
					has_playlist_stock = true;
				}
			});
		}
	
		// test if the cart has at least one heavy metal mag
		for( const ckey in cartItems ) {
			debug += "Testing mag: " + cartItems[ckey] + "\n";
			if( p_valids.includes(cartItems[ckey]) ) {
				has_one_valid = true;
				if( !inResfresh ) {
					cart_with_mag = true;
				}
				disable_option_purchase = false;
				debug += "Found a valid mag: " + cartItems[ckey] + "\n";
				break;
			}
		}
		
		// test if the cart has one playlist
		for( const ckey in cartItems ) {
			if( p_playlist == cartItems[ckey] ) {
				debug += "Found a playlist: " + cartItems[ckey] + "\n";
				has_playlist = cartKeys[ckey];
				break;
			}
		}		
		
		
		// set must_display, must_delete and shipping info
		if( has_one_valid && !has_playlist && is_cart_page && has_playlist_stock ) {
			must_display_option = true;
		} else if( (!has_one_valid || !has_playlist_stock) && has_playlist ) {
			must_delete_option = has_playlist;
		}



		/*	Process the necessary actions	*/
		/* -------------------------------- */
		/* -------------------------------- */

		if( disable_option_purchase ) {
            let buttons = document.getElementsByClassName("product-form__buttons");
            if(buttons) {
                [...buttons].forEach(button => {
                    button.style.display = 'none';
                });
            }
            // hide div of class product-form__quantity
            let quantity = document.getElementsByClassName("product-form__quantity");
            if(quantity) {
                [...quantity].forEach(qty => {
                    qty.style.display = 'none';
                });
            }

			// add a div with a message before the first div of class product-form__quantity
            let message = document.createElement('div');
			message.classList.add( msg_unavailable_class );
			message.innerHTML = msg_unavailable;
            let parent = document.getElementsByClassName("product-form__quantity")[0].parentNode;
            parent.insertBefore(message, parent.firstChild);

            debug += "Hide button because a mag is inside";
		}		

		// Display availability of option if required
		// we clean the message if it has been added before (in case of a cart update)
		let prev_message_opt = document.getElementsByClassName( msg_incentive_class );
		if( prev_message_opt ) {
			[...prev_message_opt].forEach(msg => {
				msg.style.display = 'none';
			});
		}

        console.log( "DISPLAY = " + must_display_option);
		if( must_display_option ) {
            let message_opt = document.createElement('div');
			message_opt.classList.add( msg_incentive_class );
			message_opt.innerHTML = msg_incentive;
            let parent = document.getElementsByClassName("cart__warnings")[0].parentNode;
            parent.insertBefore(message_opt, parent.firstChild);
			debug += "Must display playlist option\n";
		}

        // Update cart item quantity to 0 for the playlist item if required
		if( must_delete_option ) {
			let response = await fetch('/cart/change.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'My-Header': 'Hum-Ignore'
				},
				body: JSON.stringify({
					id: has_playlist,
					quantity: 0
				})
			});
			await response.json();
			has_display_changed = true;
			debug += "Delete option because no mag is inside";
        }

		if( !has_one_valid && cart_with_mag && inResfresh ) {
			location.reload();
		}

    } catch (error) {
        debug += "An error occurred: " + error;
    }

	if( i_debug ) {
		console.log(debug);
	}

}

document.addEventListener('DOMContentLoaded', async function () {

	// override fetch to detect cart updates
    // Save original functions to override
    const originalFetch = window.fetch;
    // Override fetch to detect cart updates
    window.fetch = async function (...args) {
        const url = args[0];
        const options = args[1] || {};
        // Check if the request is related to the cart
        if (url.includes('/cart/change') && ( !options.headers || !options.headers['Hum-Ignore'] ) ) {
            const response = await originalFetch.apply(this, args);
            if (response.ok) {
                const data = await response.clone().json();
                // Emit a custom event for cart updates
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            }
            return response;
        }
        // For non-cart requests, use the original fetch
        return originalFetch.apply(this, args);
    };

    // Listen for the custom cart update event
    document.addEventListener('cart:updated', async (event) => {
        const updatedCart = event.detail;
		const cartItems = updatedCart.items.map(item => item.handle);
		// it's only interesting to update the cart if there is a playlist inside
		if( cartItems.includes("magazine-playlist") ) {
			debug += "update cart for non playlist change\n";
		}
		await updateCart(true);

    });

	await updateCart();
});
